import { Grid, Paper } from '@material-ui/core';
import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { loopRetrackReportQuestions } from './LoopRetrackReportQuestions';
import { yupResolver } from '@hookform/resolvers/yup';
import { retrackReportLowerQuestions, retrackReportUpperQuestions } from './RetrackReportQuestions';
import RetrackReportHeader from './RetrackReportHeader';
import { useLang } from '../../../../util/lang';

const RetrackReportPreview = ({ defaultValues }) => {
    const get = useLang();
    const methods = useForm({
        defaultValues: defaultValues,
    });

    const upperConfig = retrackReportUpperQuestions();
    const lowerConfig = retrackReportLowerQuestions();
    useEffect(() => {
        methods.reset(defaultValues);
    }, [defaultValues]);

    if (defaultValues !== null) {
        // console.log('defaultValues: ', defaultValues);
        return (
            <FormProvider {...methods}>
                <Paper elevation={5}>
                    <Grid container style={{ padding: 32 }} spacing={2}>
                        {(defaultValues.archToTreat === 'BOTH' ||
                            defaultValues.archToTreat === null ||
                            defaultValues.archToTreat === 'UPPER') && (
                            <>
                                <RetrackReportHeader />
                                {loopRetrackReportQuestions(upperConfig, 'Upper', true, get)}
                            </>
                        )}

                        {(defaultValues.archToTreat === 'BOTH' ||
                            defaultValues.archToTreat === null ||
                            defaultValues.archToTreat === 'LOWER') && (
                            <>
                                <RetrackReportHeader />
                                {loopRetrackReportQuestions(lowerConfig, 'Lower', true, get)}
                            </>
                        )}
                    </Grid>
                </Paper>
                <div style={{ marginBottom: 16 }}></div>
            </FormProvider>
        );
    } else {
        return <></>;
    }
};

export default RetrackReportPreview;
